import React, { useEffect } from 'react';
import { useAgenda } from '../../hooks/agenda';

import { useAuth } from '../../hooks/auth';
import { useCategoria } from '../../hooks/categoria';
import { useClinica } from '../../hooks/clinica';
import { useFormaPagamento } from '../../hooks/formapagamento';
import { useMedico } from '../../hooks/medico';
import { usePerfil } from '../../hooks/perfil';
import { useModelo } from '../../hooks/modelo';
import { useGrupoExame } from '../../hooks/grupoExames';
import { useBeneficio } from '../../hooks/beneficio';

const SignOut: React.FC = () => {
  const { signOut } = useAuth();
  const { limparCategoria } = useCategoria();
  const { limparMedico } = useMedico();
  const { limparClinica } = useClinica();
  const { limparPerfil } = usePerfil();
  const { limparGrupo } = useGrupoExame();
  const { limparFormaPagamento } = useFormaPagamento();
  const { limparAgenda } = useAgenda();
  const { limparModelo } = useModelo();
  const { limparBeneficio } = useBeneficio();

  useEffect(() => {
    limparCategoria();
    limparMedico();
    limparPerfil();
    limparGrupo();
    limparFormaPagamento();
    limparClinica();
    signOut();
    limparAgenda();
    limparModelo();
    limparBeneficio();
  }, [
    signOut,
    limparCategoria,
    limparClinica,
    limparFormaPagamento,
    limparPerfil,
    limparGrupo,
    limparMedico,
    limparAgenda,
    limparModelo,
    limparBeneficio,
  ]);

  return <div />;
};

export default SignOut;
